"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiListExpansion = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _MuiListItemIcon = _interopRequireDefault(require("../../../MuiList/components/MuiListItem/components/MuiListItemIcon/MuiListItemIcon"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

var MuiListExpansion = function MuiListExpansion(_ref) {
  var rootClass = _ref.rootClass,
      handleClick = _ref.handleClick,
      icon = _ref.icon,
      open = _ref.open,
      primaryText = _ref.primaryText;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    button: true,
    onClick: handleClick,
    className: styles.root
  }, icon.length ? /*#__PURE__*/_react.default.createElement(_MuiListItemIcon.default, icon[0]) : null, /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: primaryText
  }), open ? /*#__PURE__*/_react.default.createElement(_icons.ExpandLess, null) : /*#__PURE__*/_react.default.createElement(_icons.ExpandMore, null)));
};

exports.MuiListExpansion = MuiListExpansion;
var _default = MuiListExpansion;
exports.default = _default;
MuiListExpansion.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Text of the List item dropdown
   */
  primaryText: _propTypes.default.string.isRequired,

  /**
   * components:
   * MuiListItemIcon
   */
  icon: function icon(props, propName, componentName) {
    var components = ['MuiListItemIcon'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /** not in storyblok passed down from parent component */
  handleClick: _propTypes.default.func.isRequired,

  /** not in storyblok passed down from parent component */
  open: _propTypes.default.bool.isRequired
};
MuiListExpansion.defaultProps = {
  rootClass: [],
  icon: []
};